import React from "react";
import { withGenericConfig } from "/contexts/generic-config-context";
import SideBySideTextAndAsset from "segments/desktop/core-components/side-by-side-text-and-asset/side-by-side-text-and-asset";
import HubspotContactForm from "segments/desktop/core-components/hubspot-contact-form/hubspot-contact-form";
import ContactSalesDetails from "./contact-sales-details";
import DefaultProps from "./default-props";

import { componentStyles } from "./hubspot-with-bullets-side-by-side-form-component.scss";

const HubspotWithBulletsSideBySideFormComponent = (props) => {
  const { isMobileOrTabletBrowser, translate } = props;
  const { formId, source, overrideCampaignId, backgroundLayers, title, titleSize, benefits, logosTitle, logos, swapTextAndAssetPosition, ...restProps } = props;
  const replaceTextComponentProps = { formId, source, overrideCampaignId, backgroundLayers: isMobileOrTabletBrowser ? 0 : backgroundLayers };
  const replaceAssetComponentProps = { title, titleSize, benefits, logosTitle, logos };

  return (
    <div className="hubspot-with-bullets-side-by-side-form-component">
      <h2 className="mobile-title">{translate(title)}</h2>
      <SideBySideTextAndAsset
        replaceTextComponent={HubspotContactForm}
        replaceAssetComponent={ContactSalesDetails}
        replaceTextComponentProps={replaceTextComponentProps}
        replaceAssetComponentProps={replaceAssetComponentProps}
        swapTextAndAssetPosition={swapTextAndAssetPosition}
        {...restProps}
      />
      <style jsx>{componentStyles}</style>
    </div>
  );
};

HubspotWithBulletsSideBySideFormComponent.defaultProps = DefaultProps;

export default withGenericConfig(HubspotWithBulletsSideBySideFormComponent);